module.exports = __webpack_public_path__ + "static/media/pagoseguro-stripe.f13b812b.png";